import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ContactCTA = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-ybro-dark px-8 py-16 lg:px-16 lg:py-24">
          {/* Background decorations */}
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-white/15 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
          
          {/* Grid pattern overlay */}
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjAyIj48cGF0aCBkPSJNMzYgMzRoLTJ2LTRoMnY0em0wLThoLTJ2LTRoMnY0em0tOCA4aC0ydi00aDJ2NHptMC04aC0ydi00aDJ2NHoiLz48L2c+PC9nPjwvc3ZnPg==')]" />

          <div className="relative text-center max-w-3xl mx-auto">
            {/* Icon */}
            <div className="w-16 h-16 rounded-2xl bg-white/15 border border-white/30 flex items-center justify-center mx-auto mb-8">
              <MessageCircle className="w-8 h-8 text-white" />
            </div>

            <h2 className="text-3xl lg:text-4xl font-bold font-heading text-white mb-6">
              Ready to Boost Your Local Visibility?
            </h2>
            <p className="text-lg text-white/80 leading-relaxed mb-10 font-body">
              Book a free, no‑obligation consultation to review your current Google Business Profile, local search performance and DMCC Act review risks.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                asChild
                size="lg"
                className="bg-white text-ybro-dark hover:bg-white/90 shadow-xl shadow-black/15 transition-all duration-300 text-base px-6 sm:px-8 py-6 h-auto font-body w-full sm:w-auto whitespace-normal text-center"
              >
                <Link to="/contact" className="flex items-center gap-2 justify-center w-full">
                  Get Your Free Consultation
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
